import gql from "graphql-tag";

export const REMOVE_ACTIVE_CHAT = gql`
  mutation ($input: activeChatInput) {
    removeActiveChat(input: $input) {
      _id
    }
  }
`;
